<template lang="pug">
  .manageIcons
    //- Barra de navegación
    van-nav-bar(
      :title="$t('addUnit.unit.setIcon')"
      left-arrow
      @click-left="close"
    )

    .main
      .addUnit__listIcon
        van-icon(
          v-for="index in maxIcons"
          :key="index"
          :name="getDeviceIcon(index)"
          :class="{select: icon === index}"
          @click="setIcon(index)")
</template>

<script>
import { ICONS } from '@/app.config';

export default {
  props: {
    icon: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    maxIcons() {
      return ICONS.SCENES;
    },
  },
  methods: {
    getDeviceIcon(index) {
      return `scene-${index}`;
    },

    setIcon(icon) {
      this.$emit('setIcon', icon);
    },

    close() {
      this.$emit('close');
    },
  },
};
</script>
